// Pages reached from somewhere other than the sidebar (the profile menu), so they belong to no
// sidebar item. While one of them is open nothing in the sidebar is selected.
const PAGES_OUTSIDE_SIDEBAR = ['/my-notifications'];

export const isOutsideSidebar = pathname =>
    PAGES_OUTSIDE_SIDEBAR.some(
        page => pathname === page || pathname?.startsWith(`${page}/`)
    );
